import script from "./DonationReturnView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationReturnView.vue?vue&type=script&setup=true&lang=ts"

import "./DonationReturnView.vue?vue&type=style&index=0&id=04f868c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f868c2"]])

export default __exports__